import { memo } from 'react';

import EmailDocumentIconSVG from '@/assets/email-document-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IEmailDocumentIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={EmailDocumentIconSVG} {...props} />
);

export const EmailDocumentIcon = memo(IEmailDocumentIcon) as typeof IEmailDocumentIcon;
